// extracted by css-extract-rspack-plugin
export default {"userProfileLink":"userProfileLink-RZCdqa","userProfileUserName":"userProfileUserName-V7mm7D","userProfileDropdown":"userProfileDropdown-EMTyWr"};